import { Component, OnInit } from '@angular/core';
import { Speaker } from '../../shared/models/speaker';
import { SACRAMENT_PROGRAM_DATA } from '../../shared/data/sacrament-program.data';

@Component({
  selector: 's9-sacrament-program',
  templateUrl: 'sacrament-program.component.html',
})
export class SacramentProgramComponent implements OnInit {
  data = SACRAMENT_PROGRAM_DATA;
  speakersBeforeRestHymn: Speaker[];
  speakersAfterRestHymn: Speaker[];

  sortSpeakers(): void {
    this.speakersBeforeRestHymn = this.data.speakers
      ? this.data.speakers.filter((s) => s.beforeRestHymn).sort((s) => s.index)
      : [];
    this.speakersAfterRestHymn = this.data.speakers
      ? this.data.speakers.filter((s) => !s.beforeRestHymn).sort((s) => s.index)
      : [];
  }

  ngOnInit(): void {
    this.sortSpeakers();
  }
}
